module.exports = __webpack_public_path__ + "img/codelos_android_install.575b8e12.gif";